export default {
  allMusicTitle: '找到心仪的音乐',
  musicAccount: '{num}+音乐'
}